
import { initialState } from "../reducers/langReducer";

// Action types
export const SET_LANGUAGE = "SET_LANGUAGE";

export const setLanguageCode = (langCode) => {
    return ({
        type: SET_LANGUAGE,
        payload: langCode
    })
};

export const setLanguageByName = (langName) => {
    const langCode = initialState.supported_languages.find(l => l.name.toLowerCase() === langName.toLowerCase()).code;
    return ({
        type: SET_LANGUAGE,
        payload: langCode
    })
}